module.exports = __webpack_public_path__ + "static/Troll-0f4039042c4f89d9d788cfd5ee7feaee.jpg";